import { createRootRoute, Outlet } from '@tanstack/react-router';

/** Route racine : les fournisseurs (thème, Query, Tooltip, Motion) vivent dans main.tsx. */
export const Route = createRootRoute({
  component: () => <Outlet />,
});
